import { render, staticRenderFns } from "./leaderApplication.vue?vue&type=template&id=16a82510&class=full-height"
import script from "./leaderApplication.vue?vue&type=script&lang=js"
export * from "./leaderApplication.vue?vue&type=script&lang=js"
import style0 from "./leaderApplication.vue?vue&type=style&index=0&id=16a82510&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a82510')) {
      api.createRecord('16a82510', component.options)
    } else {
      api.reload('16a82510', component.options)
    }
    module.hot.accept("./leaderApplication.vue?vue&type=template&id=16a82510&class=full-height", function () {
      api.rerender('16a82510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/application/leaderApplication.vue"
export default component.exports